<template>
    <v-dialog width="300" v-model="show">
        <v-card tile class="pb-4">
            <v-toolbar dark color="primary">
                <v-btn icon dark v-on:click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ this.title }}</v-toolbar-title>
            </v-toolbar>

            <v-divider />
            <v-card-actions class="mt-6">
                <v-btn class="mx-2" v-on:click="close">Cancel</v-btn>
                <v-spacer />
                <v-btn class="mx-2" v-on:click="confirm">Yes</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Are you sure?'
        },
        visible: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    data() {
        return {};
    },
    computed: {
        show: {
            get() {
                return this.visible;
            },
            set(v) {
                if (!v) {
                    this.close();
                }
            }
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        confirm() {
            this.$emit('confirm');
            this.close();
        }
    }
};
</script>
